/** Small circular handle icons for Konva Transformer (drawn on canvas, 2x). */

const BLUE = '#3b82f6';
const RED = '#e11d48';

function makeCanvas(size: number): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = size;
  c.height = size;
  return c;
}

function circleBg(ctx: CanvasRenderingContext2D, size: number, stroke: string) {
  const r = size / 2 - 1.5;
  ctx.clearRect(0, 0, size, size);
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, r, 0, Math.PI * 2);
  ctx.fillStyle = '#ffffff';
  ctx.fill();
  ctx.strokeStyle = stroke;
  ctx.lineWidth = 2.5;
  ctx.stroke();
}

/** Circular rotate arrow (blue). */
export function createRotateIcon(cssSize = 28): HTMLCanvasElement {
  const size = cssSize * 2;
  const c = makeCanvas(size);
  const ctx = c.getContext('2d')!;
  circleBg(ctx, size, BLUE);
  const cx = size / 2;
  const cy = size / 2;
  const r = size * 0.28;
  ctx.strokeStyle = BLUE;
  ctx.fillStyle = BLUE;
  ctx.lineWidth = 3;
  ctx.lineCap = 'round';
  ctx.beginPath();
  ctx.arc(cx, cy, r, -Math.PI * 0.85, Math.PI * 0.55);
  ctx.stroke();
  const tipA = Math.PI * 0.55;
  const tx = cx + r * Math.cos(tipA);
  const ty = cy + r * Math.sin(tipA);
  ctx.beginPath();
  ctx.moveTo(tx, ty);
  ctx.lineTo(tx - 7, ty - 2);
  ctx.lineTo(tx - 1, ty + 8);
  ctx.closePath();
  ctx.fill();
  return c;
}

/** Circular diagonal scale arrows (blue). */
export function createScaleIcon(cssSize = 28): HTMLCanvasElement {
  const size = cssSize * 2;
  const c = makeCanvas(size);
  const ctx = c.getContext('2d')!;
  circleBg(ctx, size, BLUE);
  ctx.strokeStyle = BLUE;
  ctx.fillStyle = BLUE;
  ctx.lineWidth = 3;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  const m = size * 0.28;
  const M = size * 0.72;
  ctx.beginPath();
  ctx.moveTo(m + 4, M - 4);
  ctx.lineTo(M - 4, m + 4);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(m, M);
  ctx.lineTo(m + 12, M);
  ctx.lineTo(m, M - 12);
  ctx.closePath();
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(M, m);
  ctx.lineTo(M - 12, m);
  ctx.lineTo(M, m + 12);
  ctx.closePath();
  ctx.fill();
  return c;
}

/** Circular red X. */
export function createDeleteIcon(cssSize = 28): HTMLCanvasElement {
  const size = cssSize * 2;
  const c = makeCanvas(size);
  const ctx = c.getContext('2d')!;
  circleBg(ctx, size, RED);
  ctx.strokeStyle = RED;
  ctx.lineWidth = 3.5;
  ctx.lineCap = 'round';
  const p = size * 0.32;
  const q = size * 0.68;
  ctx.beginPath();
  ctx.moveTo(p, p);
  ctx.lineTo(q, q);
  ctx.moveTo(q, p);
  ctx.lineTo(p, q);
  ctx.stroke();
  return c;
}

let cached: {
  rotate: HTMLCanvasElement;
  scale: HTMLCanvasElement;
  delete: HTMLCanvasElement;
  size: number;
} | null = null;

export function getSelectionIcons(cssSize = 28) {
  if (typeof document === 'undefined') {
    throw new Error('selection icons require DOM');
  }
  if (cached && cached.size === cssSize) return cached;
  cached = {
    rotate: createRotateIcon(cssSize),
    scale: createScaleIcon(cssSize),
    delete: createDeleteIcon(cssSize),
    size: cssSize,
  };
  return cached;
}
